import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBars, FaUserCircle } from 'react-icons/fa';
import { styled, colors, Box, Chip, IconButton, Menu, MenuItem } from '@mui/material';
import { deleteTokens } from '../manage_tokens';
import { config, isProduction } from '../../config';
import { SHELL_BACKGROUND } from '../sidebar/sidebar.elements';

const HeaderLayout = styled('div')(({ headerHeight }: { headerHeight: string }) => ({
    width: '100%',
    height: headerHeight,
    color: colors.grey[100],
    backgroundColor: SHELL_BACKGROUND,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: '1rem',

    '& h3': {
        fontSize: '1.05rem',
        fontWeight: 600,
        letterSpacing: '0.01em',
    },
}));

interface PropsInterface {
    toggle: boolean;
    headerHeight: string;
    setToggle: (toggle: boolean) => void;
}

export const Header = ({ toggle, setToggle, headerHeight }: PropsInterface) => {
    const navigate = useNavigate();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  
    const handleMenu = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const logout = () => {
        setAnchorEl(null);
        deleteTokens();
        navigate('/account/login');
    }

    return (
        <HeaderLayout headerHeight={headerHeight}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                <IconButton
                    aria-label="Toggle navigation"
                    size="small"
                    onClick={() => setToggle(!toggle)}
                    sx={{ color: 'inherit' }}
                >
                    <FaBars size={18} />
                </IconButton>

                <h3>Admin App</h3>

                {/* Non-production builds are flagged so it is obvious which backend
                    this tab is pointed at before anyone edits live data. */}
                {!isProduction && (
                    <Chip
                        label={config.env}
                        title={config.apiUrl}
                        size="small"
                        color="warning"
                    />
                )}
            </Box>

            <FaUserCircle
                onClick={handleMenu}
                style ={{
                    marginRight: '1.5rem',
                    fontSize: '24px',
                    cursor: 'pointer',
                    opacity: 0.85,
                }}
            />

            <Menu
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={logout}>Logout</MenuItem>
            </Menu>
        </HeaderLayout>
    )
}